import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Vuetify debe cargar ANTES que los estilos propios para que .custom-button
// (misma especificidad que .v-btn) gane siempre en el cascade, tanto en dev
// como en el build de producción. De lo contrario Vuetify pisa los botones en prod.
import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

import './assets/css/bootstrap.css'
import './assets/css/style.css'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { es } from 'vuetify/locale'

import Vue3Toastify from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import "flatpickr/dist/flatpickr.css"

import Camera from 'simple-vue-camera'   // ← nuevo import

// desactiva ResizeObserver en dev (sólo si lo necesitas)
if (process.env.NODE_ENV === 'development') {
  const ro = new ResizeObserver(() => {})
  ro.disconnect()
}

const vuetify = createVuetify({
  locale: { locale: 'es', messages: { es } },
  components,
  directives,
})

const app = createApp(App)
  .use(store)
  .use(vuetify)
  .use(router)

// registra el componente global
app.component('Camera', Camera)

app.config.globalProperties.$formatCurrency = (value, locale = 'es-MX', currency = 'MXN') =>
  new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value)

app.use(Vue3Toastify, { autoClose: 3000, position: 'top-right' })
app.use(VueGoogleMaps, { load: { key: 'AIzaSyCk_22Q7NKuXzGPD3b_baPbIjgDPCLNxCA' } })

app.mount('#app')
